import { EXPERIMENT_ENTITY_ID as EXPERIMENT_ENTITY_ID_COOKIE } from '~~/common/js/constants/cookies';
import { getQueryOverrides } from '~~/goodall/client-js/query-overrides';

export const storeModule = {
  namespaced: true,
  state: () => ({
    features: {},
    entityID: '',
    experiments: {},
  }),
  getters: {
    getExperiments: (state) => (state.experiments),
    getExperiment: (state) => (name) => (state.experiments[name]),
    getFeature: (state) => (name) => (state.features[name]),
  },
  mutations: {
    setFeature(st, { name, enabled }) {
      st.features[name] = enabled;
    },
    setEntityID(st, id) {
      st.entityID = id;
    },
    setExperiment(st, { name, variant }) {
      st.experiments[name] = variant;
    },
  },
  actions: {
    /**
     * Overwrites goodall experiments
     * based on url params which have the 'featurePrefix'
     */
    overrideFromQuery({ commit }, query) {
      if (!query || !commit) {
        return;
      }

      const overrides = getQueryOverrides(query);
      Object.entries(overrides).forEach(([name, variant]) => {
        commit('setExperiment', { name, variant });
      });
    },
    trackExperiment({ state, commit }, { name, variant }) {
      commit('setExperiment', { name, variant });
      if (Object.keys(state.experiments).length === 0) {
        return;
      }
      const maxAge = 60 * 60 * 24 * 30; // 30 days in seconds
      const options = { maxAge };
      // Set the flagr userID into a cookie so it can be reused
      if (this.$cookies) {
        this.$cookies.set(
          EXPERIMENT_ENTITY_ID_COOKIE,
          state.entityID,
          options,
        );
      }
    },
  },
};

export const storeClientPlugin = (store) => {
  store.registerModule('goodall', storeModule);
};

export default ({ store }) => {
  store.registerModule('goodall', storeModule);
};
